import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';
import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';

import type {Page} from '../add-to-audience-modal';

type Props = {
    onSelectImportType: (selectedPage: Page) => void;
};

export function Import(props: Props) {
    return (
        <GridList numColumns={2}>
            <OptionCardChooser
                key='csv'
                onClick={() => {
                    props.onSelectImportType('csv');
                }}
                illustration='import-spreadsheet'
                title='CSV Spreadsheet'
                subtitle='Import people from Microsoft Excel, Google Sheets, or any CSV spreadsheet'
            />
            <OptionCardChooser
                key='mailchimp'
                onClick={() => {
                    props.onSelectImportType('mailchimp');
                }}
                illustration='import-mailchimp'
                title='MailChimp'
                subtitle='Import people from MailChimp using your exported contacts file'
            />
            <OptionCardChooser
                key='ctct'
                onClick={() => {
                    props.onSelectImportType('ctct');
                }}
                illustration='import-constant-contact'
                title='Constant Contact'
                subtitle='Import people from Constant Contact using your exported contacts file'
            />
            <OptionCardChooser
                key='other'
                onClick={() => {
                    props.onSelectImportType('other');
                }}
                illustration='import-another-crm'
                title='Another email marketing tool'
                subtitle='Import people from any email marketing tool using your exported contacts file'
            />
        </GridList>
    );
}
